// material-ui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import logo from 'assets/images/logo/logo2.png';

// ==============================|| LOGO IMAGE COMPONENT ||============================== //

export default function LogoMain({ width = 200, height = 80  }) {
  const theme = useTheme();

  return (
    <Box
      component="img"
      src={logo}
      alt="Logo"
      sx={{
        width,
        height,
        objectFit: 'contain',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        pt: 4,
        // optional theme usage
        filter: theme.palette.mode === 'dark' ? 'brightness(0) invert(1)' : 'none',
      }}
    />
  );
}